import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { TextInput, TextArea } from 'components/core/forms';

const Container = styled.div`
  padding: 20px 40px;
  max-width: 800px;
`;
const SettingsInput = styled(TextInput)`
  display: flex;
  flex-direction: row;
  height: 44px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
`;

const InputMargin = styled.div`
  margin-top: 24px;
`;

const SettingsArea = styled(TextArea)`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border: 1px solid #d1d5db;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
`;

const SectionCreate = ({
  setNewSectionName,
  setNewSectionSummary,
  newSectionName,
  newSectionSummary,
}) => {
  return (
    <Container>
      <div>
        <SettingsInput
          reportSetting
          name="title"
          value={newSectionName}
          onChange={(e) => setNewSectionName(e.target.value)}
          label="Section Title"
        />
      </div>

      <div>
        <InputMargin>
          <SettingsArea
            name="subtitle"
            value={newSectionSummary}
            onChange={(e) => setNewSectionSummary(e.target.value)}
            label="Section Summary"
          />
        </InputMargin>
      </div>
    </Container>
  );
};

SectionCreate.propTypes = {
  setNewSectionName: PropTypes.func,
  setNewSectionSummary: PropTypes.func,
  newSectionName: PropTypes.string,
  newSectionSummary: PropTypes.string,
};

export default SectionCreate;
